import React from "react";
import { SvgIcon } from "@material-ui/core";

const Truck = props => (
  <SvgIcon viewBox="0 0 512 512" {...props}>
    <g>
      <g>
        <path
          d="M119.467,337.067c-28.237,0-51.2,22.963-51.2,51.2c0,28.237,22.963,51.2,51.2,51.2s51.2-22.963,51.2-51.2
			C170.667,360.03,147.703,337.067,119.467,337.067z M119.467,422.4c-18.825,0-34.133-15.309-34.133-34.133
			c0-18.825,15.309-34.133,34.133-34.133s34.133,15.309,34.133,34.133C153.6,407.091,138.291,422.4,119.467,422.4z"
        />
      </g>
    </g>
    <g>
      <g>
        <path
          d="M409.6,337.067c-28.237,0-51.2,22.963-51.2,51.2c0,28.237,22.963,51.2,51.2,51.2c28.237,0,51.2-22.963,51.2-51.2
			C460.8,360.03,437.837,337.067,409.6,337.067z M409.6,422.4c-18.825,0-34.133-15.309-34.133-34.133
			c0-18.825,15.309-34.133,34.133-34.133c18.825,0,34.133,15.309,34.133,34.133C443.733,407.091,428.425,422.4,409.6,422.4z"
        />
      </g>
    </g>
    <g>
      <g>
        <path
          d="M510.643,289.784l-76.8-119.467c-1.57-2.441-4.275-3.917-7.177-3.917H332.8c-4.719,0-8.533,3.823-8.533,8.533v213.333
			c0,4.719,3.814,8.533,8.533,8.533h34.133v-17.067h-25.6V183.467h80.674l72.926,113.442v82.825h-42.667V396.8h51.2
			c4.719,0,8.533-3.814,8.533-8.533V294.4C512,292.77,511.531,291.157,510.643,289.784z"
        />
      </g>
    </g>
    <g>
      <g>
        <path
          d="M375.467,277.333V217.6h68.267v-17.067h-76.8c-4.719,0-8.533,3.823-8.533,8.533v76.8c0,4.719,3.814,8.533,8.533,8.533h128
			v-17.067H375.467z"
        />
      </g>
    </g>
    <g>
      <g>
        <path
          d="M332.8,106.667H8.533C3.823,106.667,0,110.49,0,115.2v273.067c0,4.719,3.823,8.533,8.533,8.533H76.8v-17.067H17.067v-256
			h307.2v256H162.133V396.8H332.8c4.719,0,8.533-3.814,8.533-8.533V115.2C341.333,110.49,337.519,106.667,332.8,106.667z"
        />
      </g>
    </g>
    <g>
      <g>
        <rect x="8.533" y="345.6" width="51.2" height="17.067" />
      </g>
    </g>
    <g>
      <g>
        <rect x="179.2" y="345.6" width="145.067" height="17.067" />
      </g>
    </g>
    <g>
      <g>
        <rect x="469.333" y="345.6" width="34.133" height="17.067" />
      </g>
    </g>
    <g>
      <g>
        <rect x="34.133" y="140.8" width="298.667" height="17.067" />
      </g>
    </g>
    <g>
      <g>
        <rect x="110.933" y="379.733" width="17.067" height="17.067" />
      </g>
    </g>
    <g>
      <g>
        <rect x="401.067" y="379.733" width="17.067" height="17.067" />
      </g>
    </g>
    <g>
      <g>
        <rect x="34.133" y="72.533" width="119.467" height="17.067" />
      </g>
    </g>
    <g>
      <g>
        <rect y="72.533" width="17.067" height="17.067" />
      </g>
    </g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
  </SvgIcon>
);

export default Truck;
